import React from "react";
import { FaCheckCircle } from "react-icons/fa";

const PricingBlock = ({
  title,
  price,
  features,
  image,
  color,
  text,
  billingType,
  isPopular,
}) => {
  return (
    <div
      className={`cpl-item ${color}`}
      style={{ border: `2.56px solid ${color} !important` }}
    >
      <h4 className="black-text-clip">{title}</h4>
      <div className="cpl-item-content">
        {isPopular && <div className="most-popular-badge">Most Popular</div>}
        <h5 className={`price-text black-text-clip`}>{price}</h5>
        <p
          style={{ "--clip-color": color }}
          className="per-month black-text-clip"
        >
          {billingType}
        </p>
        <ul
          // style={{ "--clip-color": color }}
          className="cpl-item-list black-text-clip"
        >
          {features.map((feature, index) => (
            <li key={index}>
              <span className="cpl-check-icon">
                <FaCheckCircle />
              </span>
              <span className="black-text-clip">{feature}</span>
            </li>
          ))}
        </ul>
        <p className={`plan-text black-text-clip`}>{text}</p>
        <img src={image} alt={title} />
      </div>
    </div>
  );
};

export default PricingBlock;
